// styles
import { ReactNode } from "react";
import styles from "../styles/PageHeading.module.css";

interface PageHeadingProps {
  title: string;
  text?: string;
  subtitle?: string | ReactNode;
}

const PageHeading: React.FC<PageHeadingProps> = ({
  title,
  text,
  subtitle,
}) => {
  return (
    <>
      {title &&
        <div className={styles.heading}>
          <h1 className={styles.title}>{title}</h1>
          {text && <p className={styles.text}>{text}</p>}
          {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
        </div>
      }
    </>
  )
};

export default PageHeading;
